var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "step_age" } }, [
    _c("img", {
      staticStyle: { "max-width": "500px" },
      attrs: { src: require("../img/band-size.svg") },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("h2", [_vm._v("What is your height?")]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.lazy",
              value: _vm.$root.height,
              expression: "$root.height",
              modifiers: { lazy: true },
            },
          ],
          staticClass: "form-control",
          attrs: {
            placeholder: "put your inch height here",
            type: "number",
            min: "1",
            step: ".1",
            required: "",
          },
          domProps: { value: _vm.$root.height },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.$root, "height", $event.target.value)
            },
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }